import { Input } from './input';
var variants = {
  outline: props => Input.variants.outline(props).field
};
export default {
  variants
};